import React from 'react'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import Button from '../Button/'
import Link from '../Link'

const ProductSnippet = ({ meta, index }) => {
  const specs = meta.sentenceList
  return (
    <React.Fragment>
      {index % 2 !== 0 && <div className={styles.divider} />}
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <GatsbyImage
            image={meta.gatsbyImageData}
            objectFit="contain"
            style={{ width: '100%', height: '100%' }}
            alt={meta?.image?.description}
          />
        </div>
        <h3 className={styles.title}>{meta.title}</h3>
        <h3 className={styles.shortDescription}>{meta.subtitle.subtitle}</h3>
        <section className={styles.specificationsContainer}>
          <ul className={styles.specifications}>
            {specs.map((spec, idx) => (
              <li className={styles.specification} key={idx}>
                <span>{spec}</span>
              </li>
            ))}
          </ul>
          <span className={styles.discountTag}>Volume discounts available</span>
          <div className={styles.buttonContainer}>
            <Link to={meta.ctaUrl}>
              <Button className={styles.button}>{meta.ctaText}</Button>
            </Link>
          </div>
        </section>
      </div>
    </React.Fragment>
  )
}

export default ProductSnippet
